import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';
import { PayrollAction } from '../use-payroll-flow';

type IntroducingPayrollProps = {
  onSetPayrollAction: (action: PayrollAction) => void;
};

export const IntroducingPayroll = ({ onSetPayrollAction }: IntroducingPayrollProps) => {
  const steps: { title: string; description: string }[] = [
    {
      title: 'Setup payroll',
      description: 'Create your Payroll Run, including country, currency, and time period for your payroll.',
    },
    {
      title: 'Add Employees',
      description: 'Add the employees you want to run payroll for.',
    },
    {
      title: 'Set Payroll Information',
      description: 'Complete the payroll details for each employee, then approve and pay.',
    },
  ];
  return (
    <Stack align="stretch" className="mb-20 w-full" space={8}>
      <Stack align="stretch" className="rounded-lg bg-seapoint-gray-background-modal p-6" space={4}>
        <h2 className="text-lg font-medium leading-[22px] -tracking-[0.02em]">Introducing Payroll</h2>
        <p className="leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">
          From setup to payday, payroll is now quick, simple, and stress-free. Add your team's information and approve
          payments in just a few clicks.
        </p>
      </Stack>

      <Stack className="rounded-lg bg-seapoint-gray-background-modal p-6" space={8}>
        <Stack space={4}>
          <h2 className="text-lg font-medium leading-[22px] -tracking-[0.02em]">Getting Started with Payroll</h2>
          <p className="leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">
            Follow these three simple steps to configure, run, and approve your first payroll.
          </p>
        </Stack>
        <Stack space={6}>
          {steps.map((step, index) => (
            <Inline key={step.title} align="start" space={4} wrap="nowrap">
              <div className="flex h-10 w-10 min-w-10 items-center justify-center rounded-full bg-white text-xl shadow-sm">
                {index + 1}
              </div>
              <Stack space={1}>
                <h4 className="font-medium">{step.title}</h4>
                <p className="text-sm leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">{step.description}</p>
              </Stack>
            </Inline>
          ))}
        </Stack>
        <div className="flex w-full justify-center pt-2">
          <Button
            className="w-fit"
            onClick={() => {
              onSetPayrollAction('PAYROLL_SETUP');
            }}
          >
            Create Payroll
          </Button>
        </div>
      </Stack>
    </Stack>
  );
};
